import { Link } from 'react-router-dom';
import { BrowserImage } from '@/components/ui/BrowserImage';
import { usePublicOrgNearby } from '@/queries/publicOrgProfile';
import { buildOrgPath } from '@/lib/orgPaths';

interface OrgNearbyStripProps {
  orgSlug: string;
}

export function OrgNearbyStrip({ orgSlug }: OrgNearbyStripProps) {
  const { nearby, isLoading } = usePublicOrgNearby(orgSlug, !!orgSlug);

  if (isLoading || nearby.length === 0) return null;

  return (
    <section aria-labelledby="nearby-heading" className="border-t border-border bg-muted/20 py-10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 id="nearby-heading" className="mb-6 text-xl font-bold text-foreground">
          Nearby venues
        </h2>
        <div className="flex gap-4 overflow-x-auto pb-2">
          {nearby.map((entry) => (
            <Link
              key={entry.id}
              to={buildOrgPath({ slug: entry.slug }, '')}
              className="flex w-48 shrink-0 flex-col overflow-hidden rounded-lg border border-border bg-card transition-shadow hover:shadow-md"
            >
              <div className="flex h-24 items-center justify-center bg-muted">
                {entry.logoUrl ? (
                  <BrowserImage
                    src={entry.logoUrl}
                    alt=""
                    className="h-12 w-auto max-w-[80%] object-contain"
                    referrerPolicy="no-referrer"
                  />
                ) : (
                  <span className="px-2 text-center text-sm font-semibold">{entry.name}</span>
                )}
              </div>
              <div className="p-3">
                <p className="truncate font-medium text-foreground">{entry.name}</p>
                {entry.suburb || entry.stateOrProvince ? (
                  <p className="truncate text-xs text-muted-foreground">
                    {[entry.suburb, entry.stateOrProvince].filter(Boolean).join(', ')}
                  </p>
                ) : null}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
